export default {"src":"/_next/static/media/dashicons_email-alt.f28749cd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};